import useTranslation from 'next-translate/useTranslation';
import AffiliatesBaseSection from '@/components/Affiliates/BaseSection';
import EarningsCards from './Cards';

export default function Earnings() {
  const { t } = useTranslation('affiliates');

  return (
    <AffiliatesBaseSection title={t('earnings_title')}>
      <EarningsCards />
    </AffiliatesBaseSection>
  );
}
